<script setup lang="ts">
import { ref } from 'vue';
import { useLocale } from '@/plugins/translation';

const emit = defineEmits<{
  (e: 'do-search', searchValue: string): void;
  (e: 'clear-search'): void;
}>();

const { t, l } = useLocale();

const searchValue = ref('');

const search = () => {
  emit('do-search', searchValue.value);
};

const onClear = () => {
  searchValue.value = '';
  emit('clear-search');
};
</script>

<template>
  <v-text-field
    v-model="searchValue"
    :label="t(l.search.search)"
    single-line
    hide-details
    density="comfortable"
    clearable
    flat
    @click:clear="onClear"
    @update:model-value="search"
    @keyup.enter="search"
  ></v-text-field>
</template>

<style scoped lang="scss"></style>
